import React, { Component } from "react";
import PersonCard from "../components/PersonCard";

class Staff extends Component {
	constructor(props) {
		super(props);
		this.state = {
			people: [],
		};
	}
	componentDidMount() {
		const people = [
			{
				name: "हरि प्रसाद शर्मा",
				nameEnglish: "Hari Prashad Sharma",
				designation: "प्रमुख प्रशासकीय अधिकृत",
				designationEnglish: "Chief Administrative Officer",
				email: "info@bheemdattamun.gov.np",
				phoneEnglish: "+977-9858725111",
				phone: "+९७७-९८५८७२५१११",
				address: "भिमदत्त नगरपालिका कञ्चनपुर",
				addressEnglish: "Bhimdatta Municipality kanchanpur",
				image: "media/hamropalika/people/st1.jpg",
				containerClass: "col-sm-6 col-md-12 col-xl-6",
			},
			{
				name: "हरि सिंह धामी",
				nameEnglish: "Hari Singh Dhami",
				designation: "गुनासो तथा सूचना अधिकारी",
				designationEnglish: "Information Officer",
				email: "bmuncipality@gmail.com",
				phoneEnglish: "+977-9848723332",
				phone: "+९७७-९८४८७२३३३२ ",
				address: "भिमदत्त नगरपालिका कञ्चनपुर",
				addressEnglish: "Bhimdatta Municipality kanchanpur",
				image: "media/hamropalika/people/st2.png",
				containerClass: "col-sm-6 col-md-12 col-xl-6",
			},
		];
		this.setState({ people });
	}
	render() {
		return (
			<div className="row h-100">
				{this.state.people.map((person, index) => {
					return <PersonCard data={person} key={index} />;
				})}
			</div>
		);
	}
}

export default Staff;
